export const DEFAULT_LOCALE = 'en-US';

export const getSlug = (key, locale) => i18n.t(key, { $scope: locale || DEFAULT_LOCALE });
